import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import { normalizeFormKey } from '@/components/form/registry'
import { lsGet, lsRemove, lsSet } from '@/utils/storage'

const STORAGE_KEY = 'dev-form-renderer-key'

export const useDevFormStore = defineStore('dev-form', () => {
  const selectedKey = ref<string | null>(null)
  const initialized = ref(false)

  const hasOverride = computed(() => Boolean(selectedKey.value))

  function init() {
    if (initialized.value) return

    selectedKey.value = normalizeFormKey(lsGet(STORAGE_KEY))
    initialized.value = true
  }

  function setSelectedKey(key: string | null | undefined) {
    const normalized = normalizeFormKey(key)

    selectedKey.value = normalized

    if (normalized) {
      lsSet(STORAGE_KEY, normalized)
      return
    }

    lsRemove(STORAGE_KEY)
  }

  function clearSelectedKey() {
    setSelectedKey(null)
  }

  return {
    selectedKey,
    hasOverride,
    init,
    setSelectedKey,
    clearSelectedKey,
  }
})
